import { useNavigate, useSearch } from "@tanstack/react-router";
import { useMe } from "@/lib/session";
import { PageHeader } from "@/components/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TokensPanel } from "./TokensPanel";
import { TagsPanel } from "./TagsPanel";
import { FieldsPanel } from "./FieldsPanel";
import { SitesPanel } from "./SitesPanel";
import { KeapImportPanel } from "./KeapImportPanel";
import { AccountPanel, AuditPanel, HealthPanel, SettingsPanel } from "./SystemPanels";

const TABS = [
  ["account", "You and sign-ins"],
  ["tokens", "API and MCP tokens"],
  ["tags", "Tags"],
  ["fields", "Custom fields"],
  ["sites", "Websites"],
  ["settings", "CRM settings"],
  ["keap", "Keap import"],
  ["audit", "Audit log"],
  ["health", "System health"],
] as const;

export function SettingsPage() {
  const { tab = "account" } = useSearch({ from: "/settings" });
  const navigate = useNavigate({ from: "/settings" });
  const me = useMe();
  return (
    <div className="mx-auto max-w-[1300px]">
      <PageHeader title="Settings" />
      <Tabs value={tab} onValueChange={(t) => navigate({ search: { tab: t === "account" ? undefined : t }, replace: true })}>
        <TabsList className="flex-wrap">
          {TABS.map(([k, label]) => (
            <TabsTrigger key={k} value={k}>
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="account" className="pt-3">
          {me.data && <AccountPanel me={me.data} />}
        </TabsContent>
        <TabsContent value="tokens" className="pt-3">
          <TokensPanel />
        </TabsContent>
        <TabsContent value="tags" className="pt-3">
          <TagsPanel />
        </TabsContent>
        <TabsContent value="fields" className="pt-3">
          <FieldsPanel />
        </TabsContent>
        <TabsContent value="sites" className="pt-3">
          <SitesPanel />
        </TabsContent>
        <TabsContent value="settings" className="pt-3">
          <SettingsPanel />
        </TabsContent>
        <TabsContent value="keap" className="pt-3">
          <KeapImportPanel />
        </TabsContent>
        <TabsContent value="audit" className="pt-3">
          <AuditPanel />
        </TabsContent>
        <TabsContent value="health" className="pt-3">
          <HealthPanel />
        </TabsContent>
      </Tabs>
    </div>
  );
}
